import { MouseEvent } from 'react'
import { useDispatch } from 'react-redux'

import { useAppSelector } from 'store/store'

import { Card, CardType } from '@/entities/card'
import { Gift, selectedGiftForProductEvent, selectGifts, selectOneGiftForProduct } from '@/entities/cart'
import { giftsLsService } from '@/entities/cart/utils/gifts-ls-service'

import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'

import cl from './gift-product-card.module.scss'

type GiftProductCardProps = {
	productId: number
	type?: CardType
	gift: Gift
	adaptive?: boolean
}

export const GiftProductCard = (props: GiftProductCardProps) => {
	const { type = 'regular', productId, gift, adaptive } = props

	const dispatch = useDispatch()
	const productGift = useAppSelector(state => selectGifts.selectById(state, productId))
	const isSameGift = productGift?.ID === gift?.ID

	const selectGift = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		// Нормализуем gift, чтобы он был привязан к текущему productId
		const normalized: Gift = { ...gift, PRODUCT_IDS: [productId] }

		// НОВАЯ АРХИТЕКТУРА: обновляем ProductGiftConfig
		dispatch(selectOneGiftForProduct({ productId, gift: normalized }))

		// СТАРАЯ ЛОГИКА (deprecated):
		dispatch(selectedGiftForProductEvent({ gift: normalized }))

		// Немедленно сохраним выбор в LS, чтобы fast-страница смогла его прочитать
		try {
			giftsLsService.setSingle(productId, gift.ID)
		} catch (_) {}
	}

	return (
		<Card
			type={type}
			data={{
				title: gift.TITLE,
				images: [gift.IMAGE],
				productCode: gift.KOD
			}}
			adaptive={adaptive}
			className={cl.giftCard}
			bottomController={
				<>
					<Text size="7" weight="bold" className={cl.giftName}>
						Подарок
					</Text>
					{isSameGift ? (
						<Button size="M" className={cl.button} theme="outlined">
							Выбран
						</Button>
					) : (
						<Button size="M" className={cl.button} onClick={selectGift}>
							Выбрать
						</Button>
					)}
				</>
			}
		/>
	)
}
